class productMediaDots extends HTMLElement {
  constructor() {
    super();
    this.dots = this.querySelectorAll('.product-dots__dot');

    this.qParams = new URLSearchParams(window.location.search);  
    if(this.qParams.has('gender') && ['male', 'female'].includes(this.qParams.get('gender'))) {
      for (let i = 0; i < this.dots.length; i++) {
        let dot = this.dots[i];
        if(dot.dataset.gender && dot.dataset.gender != this.qParams.get('gender')) {
          dot.parentNode.removeChild(dot);
        }
      }
      this.dots = this.querySelectorAll('.product-dots__dot');
    }  
    this.dots.forEach((dot, index) => {
      dot.classList.remove('hidden');
    });

    setTimeout(() => this.observeImages(), 2000);
    this.productImages = [...document.querySelectorAll('.product__media-item')];
  }

  handleDotsActive (loopIndex, toggle) {
    const mediaDot = document.querySelector(`[data-product-media-dot][data-loop-index="${loopIndex}"]`);
    if (toggle == 'add') {
      mediaDot.classList.add("is-active");
    } else {
      mediaDot.classList.remove("is-active");
    }
  }

  observeImages() {


    const handleDotsIntersection = (images) => {
      images.forEach((image) => {
        if (image.isIntersecting) {
          this.handleDotsActive(image.target.getAttribute('data-loop-index'), 'add');
        } else {
          this.handleDotsActive(image.target.getAttribute('data-loop-index'), 'remove');
        }
      });
    }

    const dotsObserver = new window.IntersectionObserver(handleDotsIntersection, { threshold: 0.5 });

    this.productImages.forEach(image => {
      dotsObserver.observe(image);
    });
  }
}

customElements.define('product-media-dots', productMediaDots);